// TODO - Trim this list to only the connection types which use the managed keychain once ServerConfigurableConnections is on
export let OAuthCredentialTypes = {
  Salesforce: 'salesforce',
  BigQuery: 'bigquery',
  GoogleAnalytics: 'google-analytics',
  GoogleSheets: 'google-sheets',
  WebDataProprietary: 'webdata-direct',
  QuickBooks: 'webdata-direct:intuit-quickbooks',
  Marketo: 'webdata-direct:marketo-marketo',
  Eloqua: 'webdata-direct:oracle-eloqua',
  Anaplan: 'webdata-direct:anaplan-anaplan',
  Box: 'box',
  OneDrive: 'onedrive',
  Dropbox: 'dropbox',
  Slack: 'slack',
  TableauOnlinAuthorizationServer: 'tableau-online-authorization-server'
};

export interface IOAuthConfigInfo {
  oauthConfigId: string;
  supportsCustomDomain: boolean;
}

export interface IOAuthCredential {
  id: string;
  type: string; // class name
  username: string;
  instanceUrl: string;
  role: string;
  oauthConfigId?: string;
  serviceAccountCredential?: boolean;
}

export interface IOAuthCredentialTypeInfo {
  type: string;
  supportsGenericAuth: boolean;
  supportsCustomDomain: boolean;
  supportsTestToken: boolean;
  displayNames?: { [locale: string]: string };
  oauthConfigInfoList?: IOAuthConfigInfo[];
}
